import { ESdChangeReason, EWFNodeType, IConditionModel, IWFDecision } from "@kuika/kuika-cl-model";
import { ConditionSetType } from "@kuika/kuika-cl-model/src/models/builder.dtos";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../../shared/pure-sd";
import { Comparison } from "../../properties-panel/condition";

export interface IWorkFlowDecisionPropertiesState {}

export interface IWorkFlowDecisionPropertiesProps {
  decisionId: string;
}

class WorkFlowDecisionProperties extends PureSdComponent<
  IWorkFlowDecisionPropertiesProps & IWithSDProps & IWithContextProp,
  IWorkFlowDecisionPropertiesState
> {
  constructor(props: IWorkFlowDecisionPropertiesProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  handleCondition = async (condition: IConditionModel) => {
    const wf = this.props.sd.selectedWf;
    const decisionArrow = this.props.sd.findNodeRecursively(this.props.decisionId, EWFNodeType.Arrow, wf!) as
      | IWFDecision
      | undefined;
    if (wf && decisionArrow) {
      decisionArrow.condition = condition;
      await this.props.sd.saveWorkFlow(wf, ESdChangeReason.WFStepMappingChange);
      relintWorkflowSafely();
    }
  };

  waitAndHandleCondition = _.debounce((event: any) => this.handleCondition(event), 150);

  render = () => {
    const wf = this.props.sd.selectedWf;
    const decisionArrow = this.props.sd.findNodeRecursively(this.props.decisionId, EWFNodeType.Arrow, wf!) as
      | IWFDecision
      | undefined;
    if (decisionArrow === undefined) {
      return <></>;
    }
    decisionArrow.condition;
    if (decisionArrow.condition === undefined) {
      decisionArrow.condition = {
        conditionSet: { conditions: [], type: ConditionSetType.and },
        id: Guid.create().toString(),
        isOrGroup: false
      } as IConditionModel;
    }

    return (
      <div className="kuika_blue_panel" style={{ margin: "16px 8px" }}>
        <Comparison
          condition={decisionArrow.condition}
          onChange={this.waitAndHandleCondition}
          conditionType="workflow"
          executePointer={decisionArrow.name}
        />
      </div>
    );
  };

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return true;
  };
}

function relintWorkflowSafely() {
  try {
    const g: any = (globalThis as any).__kuika_LINT_CTX;
    const modeler = g?.modeler;
    if (!modeler || typeof modeler.get !== "function") return;

    const linting = modeler.get("linting");
    const eventBus = modeler.get("eventBus");
    const elementRegistry = modeler.get("elementRegistry");

    if (linting && typeof linting.update == "function") {
      linting.update();
    }

    if (eventBus && elementRegistry && typeof elementRegistry.getAll === "function") {
      const all = elementRegistry.getAll();
      eventBus.fire("elements.changed", { elements: all });
    }
  } catch {}
}

const workFlowDecisionProperties = withContext<IWorkFlowDecisionPropertiesProps>(
  withSD<IWorkFlowDecisionPropertiesProps>(WorkFlowDecisionProperties)
);
export { workFlowDecisionProperties as WorkFlowDecisionProperties };
